/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CouponValidateView } from '../models/CouponValidateView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CouponService {
    /**
     * Validate a coupon code for a product before checkout
     * @param code
     * @param productId
     * @returns CouponValidateView Validation result (valid=false carries reason + message, HTTP 200)
     * @throws ApiError
     */
    public static getAppCouponValidate(
        code: string,
        productId: string,
    ): CancelablePromise<CouponValidateView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/coupon/validate',
            query: {
                'code': code,
                'productId': productId,
            },
            errors: {
                400: `Missing parameters or unknown product`,
            },
        });
    }
}
